import { render, staticRenderFns } from "./PrescreeningModal.vue?vue&type=template&id=52cc16c8&scoped=true"
import script from "./PrescreeningModal.vue?vue&type=script&lang=js"
export * from "./PrescreeningModal.vue?vue&type=script&lang=js"
import style0 from "./PrescreeningModal.vue?vue&type=style&index=0&id=52cc16c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cc16c8",
  null
  
)

export default component.exports